@if (product(); as product) {
  <product-card [product]="product" [hoverable]="false" />
}
